export const createTodo = obj => ({
  type: 'CREATE_TODO',
  todo: obj,
});

export const toggleStatus = index => ({
  type: 'TOGGLE_STATUS',
  todoIndex: index,
});

export const sortTodos = () => ({
  type: 'SORT_TODOS',
});

export const deleteTodo = index => ({
  type: 'DELETE_TODO',
  todoIndex: index,
});

export const toggleHide = () => ({
  type: 'TOGGLE_HIDE',
});

export const toggleEditMode = index => ({
  type: 'TOGGLE_EDITMODE',
  todoIndex: index,
});

export const updateTodo = (obj, index) => ({
  type: 'UPDATE_TODO',
  todo: obj,
  todoIndex: index,
});

export const deleteAll = () => ({
  type: 'DELETE_ALL',
});

export const deleteDone = () => ({
  type: 'DELETE_DONE',
});
